import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getViewAdmin = (params) => {
    return axios.get(`${backendHost}/api/admin/allows`, {params});
};

export {
    getViewAdmin
}